// Este é o URL base para carregar as imagens públicas do seu Storage
export const uploadsUrl =
  "https://aouxjcncxgosbyqtsiug.supabase.co/storage/v1/object/public";